import { cn } from "@/lib/utils";

// Soft translucent tone (works in light + dark) + subtle indicator dot.
const TONES = {
  neutral: "bg-muted text-foreground/80 ring-border/60",
  blue: "bg-primary/10 text-primary ring-primary/20",
  green: "bg-emerald-500/10 text-emerald-700 ring-emerald-500/20 dark:text-emerald-400",
  amber: "bg-amber-500/10 text-amber-700 ring-amber-500/20 dark:text-amber-400",
  red: "bg-rose-500/10 text-rose-700 ring-rose-500/20 dark:text-rose-400",
};

const DOT = {
  neutral: "bg-muted-foreground",
  blue: "bg-primary",
  green: "bg-emerald-500",
  amber: "bg-amber-500",
  red: "bg-rose-500",
};

export function StatusBadge({ label, tone = "neutral", dot = true, className, testId }) {
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-[11px] font-semibold ring-1 ring-inset",
        TONES[tone],
        className
      )}
    >
      {dot && <span className={cn("h-1.5 w-1.5 rounded-full shadow-[0_0_6px_currentColor]", DOT[tone])} />}
      {label}
    </span>
  );
}
